// 分销管理————分销商户管理
import http from "@/utils/request";

// 创建渠道商家/编辑渠道商户
export function httpMerchantAdd(data: any) {
  return http.post<Res.response<any>>({
    url: "/distribution/merchant/add",
    data,
  });
}
// 分销商户列表
export function httpMerchantList(data: any) {
  return http.post<Res.response<any>>({
    url: "/distribution/merchant/list",
    data,
  });
}

// 修改记录
export function httpMerchantUpdateRecord(data: { pageNum: any; pageSize: any; id: any }) {
  return http.get<Res.response<any>>({
    url: "/distribution/merchant/update/record?pageNum=" + data.pageNum + "&pageSize=" + data.pageSize + "&id=" + data.id,
  });
}
